import { render, staticRenderFns } from "./body1.vue?vue&type=template&id=0c76fa41&scoped=true&"
import script from "./body1.vue?vue&type=script&lang=js&"
export * from "./body1.vue?vue&type=script&lang=js&"
import style0 from "./body1.vue?vue&type=style&index=0&id=0c76fa41&lang=less&scoped=true&"
import style1 from "./body1.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c76fa41",
  null
  
)

export default component.exports